import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
export const ColorDisplayButton = t0 => {
  const $ = _c(19);
  const {
    title,
    color,
    colorKey,
    open
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <p className="font-mono text-base/8 font-medium tracking-wide uppercase">{title}</p>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== color) {
    t2 = <div className="inset-ring-border size-3.5 rounded-full inset-ring" style={{
      backgroundColor: color
    }} />;
    $[2] = color;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${colorKey}-color-display`;
  const t4 = open && "hidden";
  let t5;
  if ($[4] !== t4) {
    t5 = cn("text-muted-foreground font-mono font-light uppercase", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== color || $[7] !== t3 || $[8] !== t5) {
    t6 = <div id={t3} className={t5}>{color}</div>;
    $[6] = color;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `${colorKey}-color-input`;
  let t8;
  if ($[10] !== t7) {
    t8 = <div id={t7} />;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t6 || $[14] !== t8) {
    t9 = <div className="flex items-center gap-1">{t2}{t6}{t8}</div>;
    $[12] = t2;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t1 || $[17] !== t9) {
    t10 = <div className="flex flex-col items-start">{t1}{t9}</div>;
    $[16] = t1;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};